import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export interface Client {
  id: string;
  email: string;
  name: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string;
  status: 'active' | 'inactive';
  user_id?: string;
  created_at: number;
  updated_at: number;
}

export interface CreateClientData {
  email: string;
  name: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string;
  user_id?: string;
}

export interface UpdateClientData {
  name?: string;
  phone?: string;
  address?: string;
  company?: string;
  tax_id?: string;
  status?: 'active' | 'inactive';
}

export const clientService = {
  async getClients(): Promise<Client[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients`);
    return response.data || [];
  },

  async getClient(id: string): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`);
    return response.data;
  },

  async createClient(data: CreateClientData): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async updateClient(id: string, data: UpdateClientData): Promise<Client> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async deleteClient(id: string): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/clients/${id}`, {
      method: 'DELETE',
    });
  },

  async toggleClientStatus(id: string): Promise<Client> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/clients/${id}/toggle`,
      { method: 'PATCH' }
    );
    return response.data;
  },
};